// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18Hbu","label":"styles_label__2ggmW"};